import { CommonModule } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { Component, ViewChild, input, ChangeDetectionStrategy } from '@angular/core';

import { InfoboxComponent } from '@core/components-infobox-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { CompanyVerificationRequestStatus } from '@core/spam-verification-types';

@Component({
  selector: 'rt-spam-verification-status-infobox',
  templateUrl: './spam-verification-status-infobox.component.html',
  styleUrls: ['./spam-verification-status-infobox.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, InfoboxComponent, TranslatePipe],
})
export class SpamVerificationStatusInfoboxComponent {
  public readonly status = input<CompanyVerificationRequestStatus>(undefined!);

  @ViewChild('companyVerificationRequestStatusRejected', { static: true })
  public companyVerificationRequestStatusRejected: TemplateRef<any>;
  @ViewChild('companyVerificationRequestStatusApproved', { static: true })
  public companyVerificationRequestStatusApproved: TemplateRef<any>;
  @ViewChild('companyVerificationRequestStatusFormSubmitted', { static: true })
  public companyVerificationRequestStatusFormSubmitted: TemplateRef<any>;

  public activeTemplate: TemplateRef<any> | null;

  public ngOnChanges(): void {
    this.activeTemplate = this.resolveInfoboxTemplate();
  }

  private resolveInfoboxTemplate(): TemplateRef<any> | null {
    switch (this.status()) {
      case CompanyVerificationRequestStatus.Approved:
        return this.companyVerificationRequestStatusApproved;

      case CompanyVerificationRequestStatus.Rejected:
        return this.companyVerificationRequestStatusRejected;

      case CompanyVerificationRequestStatus.FormSubmitted:
        return this.companyVerificationRequestStatusFormSubmitted;

      default:
        return null;
    }
  }
}
